import { Injectable } from "@angular/core";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { RegionModel } from "../models/region";
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Injectable({
  providedIn: "root",
})
export class RegionProvider {
  regions: RegionModel[] = [];
  cities: any[] = [];
  states: any[] = [];
  actionSuccess: boolean = false;

  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration
  ) {
    this.getAllStates();
    this.getRegionList()
  }

  getRegionList(): void {
    this.apiService
      .getHeaders(this.apiConfig.configGetRegion)
      .subscribe((res: any) => {
        this.regions = res.body.data.region as RegionModel[];
        if (this.regions.length > 0) {
          this.regions = this.regions.filter((i) => i.year_2021 == 1);
        }
      });
  }

  getAllCities() {
    this.apiService.getHeaders(this.apiConfig.configGetCities).subscribe(
      (res: any) => {
        this.cities = res.body.data.cities;
        this.states = res.data.state_list;
      },
      (err) => {
        console.log(err);
      }
    );
  }
  getAllStates(){
    this.apiService.get(this.apiConfig.configGetStates).subscribe((res:any)=>{
      this.states = res.data
    },(err)=>{
      this.toast.Error(err)
    })
  }

  regionAdd(formData: RegionModel) {
    let apiUrl = this.apiConfig.configAddRegion;
    this.apiService.post(apiUrl, formData).subscribe(
      (res: any) => {
        this.actionSuccess = true;
        if (!formData.id) {
          this.regions.push(formData);
        }
        this.regions.forEach((b) => {
          if (formData.region_name && b.id == formData.id) {
            b.region_name = formData.region_name;
          }
        });

        this.toast.Success(res.body.data.message);
      },
      (err) => {
        console.log("err", err);
      }
    );
  }

  regionEdit(formData: any) {
    let apiUrl = this.apiConfig.configUpdateRegion;
    this.apiService.post(apiUrl, formData).subscribe(
      (res: any) => {
        this.actionSuccess = true;
        let updateIndex = this.regions.findIndex(
          (item) => item.id == formData.region_id
        );
        this.regions[updateIndex].id = formData.region_id;
        this.regions[updateIndex].region_name = formData.region_name;
        this.toast.Success(res.body.data.message);
      },
      (err) => {
        console.log("err", err);
      }
    );
  }

  regionDelete(formData: any) {
    let apiUrl = this.apiConfig.configDeleteRegion;
    this.apiService.post(apiUrl, formData).subscribe(
      (res: any) => {
        this.actionSuccess = true;
        let updateIndex = this.regions.findIndex(
          (item) => item.id == formData.region_id
        );
        this.regions.splice(updateIndex, 1);
        this.toast.Success(res.body.data.message);
      },
      (err) => {
        console.log("err", err);
      }
    );
  }
}
// let updatedRegions =this.regions.splice(updateIndex, 1);
